import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import PremiumBadge from "./PremiumBadge.js";
import FormControl from "@material-ui/core/FormControl";

export default props => (
    <FormControl style={{ width: "100%", marginTop: "10px" }}>
        <InputLabel id={props.text} disabled={props.disabled}>
            {props.text}
        </InputLabel>
        <Select
            style={{ width: "100%" }}
            labelId={props.text}
            id={props.text}
            value={props.prop === 0 ? "" : props.prop}
            onChange={event => props.changeValue(event.target.value)}
            disabled={props.disabled}
            IconComponent={() => (props.disabled ? <PremiumBadge /> : null)}>
            <MenuItem value={props.value1 || true}>{props.choice1 || "Ja"}</MenuItem>
            <MenuItem value={props.value2 || false}>{props.choice2 || "Nej"}</MenuItem>
        </Select>
    </FormControl>
);
